import Vue from 'vue'
import VueRouter from 'vue-router'
import bus from '@/utils/bus'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const Surveylist = () => import('../views/list')
const SurveyaddList = () => import('../views/addList')
const Surveyedit = () => import('../views/edit')
const SurveyPreview = () => import('../views/preview')
const SurveyView = () => import('../views/view')

const routeList = [
  { path: '/', redirect: '/list' },
  { path: '/list', meta: { title: '发布会列表' }, name: 'Surveylist', component: Surveylist },
  { path: '/addList', meta: { title: '新增发布会' }, name: 'SurveyaddList', component: SurveyaddList },
  { path: '/edit', meta: { title: '编辑发布会' }, name: 'Surveyedit', component: Surveyedit },
  { path: '/preview', meta: { title: '预览发布会' }, name: 'SurveyPreview', component: SurveyPreview },
  { path: '/view', meta: { title: '发布会详情', boxHeaderHidden: true, view: true }, name: 'SurveyView', component: SurveyView },
]

const router = new VueRouter({
  mode: 'hash',
  routes: routeList
});
router.beforeEach((to, from, next) => {
  bus.$emit('message', 'hello');
  next();
});
export default router
